import { NormalTextInputField } from "@/components";
import React from "react";

const MediaCenterSecondTabCMSFormFields = ({
  selectedTab,
  formData,
  isFetching,
  handleTextInputChange,
}) => {
  return (
    <>
      {selectedTab === "section-1" && (
        <>
          {/* Heading */}
          <NormalTextInputField
            isFetching={isFetching}
            labelText="Heading"
            fieldId="photo-gallery-heading"
            fieldName="photo-gallery-heading"
            placeholderText="Heading"
            inputValue={formData?.["photo-gallery-heading"] || ""}
            onChangeTextInputField={handleTextInputChange}
            translateField={true}
          />

          {/* Description */}
          <NormalTextInputField
            isFetching={isFetching}
            isTextArea={true}
            labelText="Description"
            fieldId="photo-gallery-description"
            fieldName="photo-gallery-description"
            placeholderText="Description"
            inputValue={formData?.["photo-gallery-description"] || ""}
            onChangeTextInputField={handleTextInputChange}
            translateField={true}
            extraContainerClasses="mt-5"
          />
        </>
      )}
    </>
  );
};

export default MediaCenterSecondTabCMSFormFields;
